import { logger } from 'rum';


export default logger;
